import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function SupportPage() {

    return (

        <DashboardLayout>

            <div style={{ padding: "30px" }}>

                <h1>Support</h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}